/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketIntegrationNoteCreateDto } from '../../models/ticket-integration-note-create-dto';
import { TicketIntegrationNoteItem } from '../../models/ticket-integration-note-item';

export interface TicketControllerCreateIntegrationNote$Params {
  id: number;
      body: TicketIntegrationNoteCreateDto
}

export function ticketControllerCreateIntegrationNote(http: HttpClient, rootUrl: string, params: TicketControllerCreateIntegrationNote$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketIntegrationNoteItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerCreateIntegrationNote.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketIntegrationNoteItem;
      }>;
    })
  );
}

ticketControllerCreateIntegrationNote.PATH = '/ticket/{id}/integration-notes';
